module.exports = __webpack_public_path__ + "static/media/video1.30b2f77c.mp4";